import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import ScrollReveal from './ScrollReveal.jsx';
import SectionAmbientGradient from './SectionAmbientGradient.jsx';

/**
 * Encabezado de página interna con gradiente azul (mismo estilo que Contacto).
 */
export default function PublicPageHero({
  backTo = '/',
  backLabel = 'Volver al inicio',
  eyebrow,
  title,
  description,
  descriptionClassName = 'mt-5 text-lg leading-relaxed text-slate-300',
}) {
  return (
    <section className="relative overflow-hidden border-b border-white/10">
      <SectionAmbientGradient />
      <div className="relative mx-auto max-w-7xl px-6 py-14 lg:px-8 lg:py-16">
        <Link
          to={backTo}
          className="inline-flex items-center gap-2 text-sm font-semibold text-accent-lime transition hover:text-white"
        >
          <ChevronLeft className="h-4 w-4" aria-hidden />
          {backLabel}
        </Link>
        <ScrollReveal className="mx-auto mt-10 max-w-3xl text-center">
          {eyebrow ? (
            <p className="text-xs font-semibold uppercase tracking-[0.28em] text-accent-lime">{eyebrow}</p>
          ) : null}
          {title ? (
            <h1 className="mt-4 font-display text-3xl font-bold text-white md:text-4xl">{title}</h1>
          ) : null}
          {description ? (
            <p className={descriptionClassName}>{description}</p>
          ) : null}
        </ScrollReveal>
      </div>
    </section>
  );
}
